import type { AppConfig } from "./types";

const production: AppConfig = {
  adobeFontsKitId: "nyi0urp",
  auth0ClientId: "9jPVfVJj05KwAOrjAfaQCuS6USelkZcG",
  auth0CustomDomain: "auth.rtspro.com",
  auth0Domain: "stc-production.us.auth0.com",
  enforceForthLeafAccess: true,
  featureServiceUrl: "https://feature-service.rtspro.com/",
  forthLeafPermission: "internal.Admintools.User",
  usersServiceUrl: "https://sentinel-service.carrierpro.com/user/",
};

export default production;
